import XHRFetch from './XHRFetch';

export function getGitInfo() {
    const promise = XHRFetch('GET', '/git-info.json', null)
        .then(
            (response) => {
                const msg = JSON.parse(response.responseText);
                return { error: false, message: msg };
            },
            (error) => ({
                error: true,
                message: 'Network problem',
            }),
        )
        .then(
            (response) => response,
            (error) => ({
                error: true,
                message: error,
            }),
        );

    return promise;
}
